import { gql } from "@apollo/client";

export const UPDATE_ASSET = gql`
  mutation updateAsset($input: UpdateAssetInput!) {
    updateAsset(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const CREATE_ASSET = gql`
  mutation createAsset($input: CreateAssetInput!) {
    createAsset(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RETRIEVE_ASSET_IMAGE = gql`
  mutation retrieveAssetImage($input: RetrieveAssetImageInput!) {
    retrieveAssetImage(input: $input) {
      commandId
      correlationId
    }
  }
`;
